<template>
  <div :class="$style.base" data-pw="illustration">
    <img
      :src="path"
      :class="[
        size === 'big' ? $style.big : $style.small
      ]"
      data-pw="illustration__img"
    >
    <BaseText>
      <slot />
    </BaseText>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import BaseText from '~/base/components/text/Text.vue'

enum IllustrationType {
  'alert',
  'app-confirm',
  'calendar-reload',
  'calendar',
  'confirm',
  'contact',
  'covid',
  'date-confirm',
  'error-404',
  'ista-car',
  'lost-connection',
  'message-sent',
  'no-timeslot-available',
  'person'
}

interface Props {
  type: keyof typeof IllustrationType,
  size?: 'small' | 'big'
}

const { type, size = 'small' } = defineProps<Props>()

const path = computed((): string => {
  return new URL(
    `../../assets/illustrations/${type}.svg`,
    import.meta.url
  ).href
})
</script>

<style module>
.base {
  width: 100%;
  margin: 0 auto;
  text-align: center;
    * + & {
      margin-top: var(--space-md)
  }
}

.small {
  height: 115px;
  width: 115px;
}

.big {
  height: 200px;
  width: 200px;
}
</style>
